import { ReactNode } from 'react';

type ChipKind = 'type' | 'status' | 'warn' | 'neutral';

interface ChipProps {
  kind: ChipKind;
  value?: string;
  children?: ReactNode;
  className?: string;
}

export const typeClass = (t: string) => `type-${t.toLowerCase()}`;
export const statusClass = (s: string) => `status-${s.toLowerCase().replace(/\s+/g, '-')}`;

export const Chip = ({ kind, value, children, className = '' }: ChipProps) => {
  const modifier =
    kind === 'type' && value ? typeClass(value)
      : kind === 'status' && value ? statusClass(value)
      : kind === 'warn' ? 'warn'
      : 'neutral';
  return (
    <span className={`chip ${modifier} ${className}`.trim()}>
      <span className="dot" style={{ background: 'currentColor' }} />
      {children ?? value}
    </span>
  );
};

export default Chip;
